"use client";

import { Box } from "@chakra-ui/react";
import { Text } from "@/components/ui";
import { useThemeTokens } from "@/lib/theme/tokens";
import { ContentSettingsText } from "@/lib/utils/content-settings/ContentSettingsText";
import { PublicEntrance } from "@/components/shared/motion";

interface MicrositeListingHeroProps {
  subtitle: string;
  title: string;
  description: string;
  studioName?: string | null;
  tenantEmail?: string | null;
}

/** Shared hero block for public listing pages (classes, teachers, locations). */
export function MicrositeListingHero({
  subtitle,
  title,
  description,
  studioName,
  tenantEmail,
}: MicrositeListingHeroProps) {
  const theme = useThemeTokens();

  return (
    <PublicEntrance variant="hero" as="section">
      <Box>
        <Text
          fontSize="xs"
          textTransform="uppercase"
          letterSpacing="0.18em"
          color={theme.text.tertiary}
          mb={2}
        >
          {subtitle}
        </Text>
        <Text
          as="h1"
          fontSize={{ base: "2xl", md: "3xl" }}
          fontWeight="600"
          letterSpacing="-0.03em"
          color={theme.text.primary}
          mb={3}
          lineHeight="1.2"
        >
          {title}
        </Text>
        <ContentSettingsText
          variant="secondary"
          fontSize="md"
          lineHeight="1.6"
          maxW="720px"
          studioName={studioName}
          tenantEmail={tenantEmail}
        >
          {description}
        </ContentSettingsText>
      </Box>
    </PublicEntrance>
  );
}
